<h1 mat-dialog-title>
  {{ dialogTitle }}
</h1>
<mat-stepper mat-dialog-content #stepper="matStepper">
  <mat-step [stepControl]="moldForm" label="Seleccion o creacion de molde">
    <app-mold-dialog-create-mold
      (finish)="stepper.next()"
    ></app-mold-dialog-create-mold>
  </mat-step>
  <mat-step
    [stepControl]="suffixForm"
    label="Datos basicos del molde"
    *ngIf="selectBasic"
  >
    <ng-container [ngTemplateOutlet]="templateSuffixForm"></ng-container>
  </mat-step>
  <mat-step
    label="Seleccionar maquinas"
    *ngIf="selectMachines && showFormMachines"
  >
    <ng-container [ngTemplateOutlet]="templateSelectMachines"></ng-container>
  </mat-step>
  <mat-step
    label="Seleccionar las placas de base"
    *ngIf="selectBasePlates && showStepSelectionBasePlates"
  >
    <ng-container [ngTemplateOutlet]="templateSelectBasePlates"></ng-container>
  </mat-step>
  <mat-step *ngFor="let step of extraSteps" [label]="step.label">
    <ng-container [ngTemplateOutlet]="step.template"></ng-container>
  </mat-step>
  <!--  <mat-step-->
  <!--    label="Cortes especificos"-->
  <!--    *ngIf="selectItemCavities && showStepCavities"-->
  <!--  >-->
  <!--    <ng-container [ngTemplateOutlet]="templateAssemblyItem"></ng-container>-->
  <!--  </mat-step>-->
</mat-stepper>

<!--FORM FOR SUFFIX INFORMATION-->
<ng-template #templateSuffixForm>
  <form [formGroup]="suffixForm">
    <mat-form-field class="one-third" appearance="outline">
      <mat-label>Sufijo</mat-label>
      <input type="text" matInput formControlName="suffix" />
    </mat-form-field>
    <mat-form-field class="two-thirds" appearance="outline">
      <mat-label>Localización</mat-label>
      <mat-select formControlName="location">
        <mat-option>
          <ngx-mat-select-search
            formControlName="searchLocation"
            placeholderLabel="Buscar..."
            noEntriesFoundLabel="Sin resultados"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option [value]="op.id" *ngFor="let op of locationOptions$ | async">
          {{ op.title }}
        </mat-option>
        <!--        <mat-option value="Reparación"> Reparación </mat-option>-->
      </mat-select>
    </mat-form-field>
    <ng-container
      [ngTemplateOutlet]="templateStepperButtons"
      [ngTemplateOutletContext]="{
        showBefore: true,
        blockNext: !suffixForm.valid,
        showNext:
          showFormMachines ||
          selectBasePlates ||
          showStepSelectionBasePlates ||
          selectItemCavities
      }"
    ></ng-container>
  </form>
</ng-template>
<ng-template #templateSelectMachines>
  <form>
    <app-chips-input
      placeHolder="Seleccionar maquinas"
      inputLabel="Maquinas"
      [data]="machines"
      [(selectedValues)]="selectedMachines"
      [groupVisually]="true"
      [groupMinCount]="3"
      [groupLabelMap]="{ Ferry: 'Ferris' }"
    >
    </app-chips-input>
    <ng-container
      [ngTemplateOutlet]="templateStepperButtons"
      [ngTemplateOutletContext]="{
        showBefore: true,
        showNext:
          (selectBasePlates && showStepSelectionBasePlates) ||
          selectItemCavities
      }"
    ></ng-container>
  </form>
</ng-template>

<ng-template #templateSelectBasePlates>
  <form>
    <app-chips-input
      placeHolder="Seleccionar placas bases"
      inputLabel="Placas bases"
      [data]="basePlates"
      [(selectedValues)]="selectedBasePlates"
    ></app-chips-input>
    <ng-container
      [ngTemplateOutlet]="templateStepperButtons"
      [ngTemplateOutletContext]="{
        showBefore: true,
        showNext: false
      }"
    ></ng-container>
  </form>
</ng-template>

<mat-dialog-actions>
  <ng-container
    *ngIf="!!templateButtons"
    [ngTemplateOutlet]="templateButtons"
    [ngTemplateOutletContext]="{
      valid: !suffixForm.valid || !moldForm.valid
    }"
  ></ng-container>
  <ng-container
    *ngIf="!templateButtons"
    [ngTemplateOutlet]="templateCloseButtons"
  >
  </ng-container>
</mat-dialog-actions>

<ng-template #templateCloseButtons>
  <button mat-raised-button mat-dialog-close class="app-btn-close">
    Cancelar
  </button>
  <button
    mat-raised-button
    [disabled]="!suffixForm.valid || !moldForm.valid"
    class="app-btn-save"
    (click)="closeDialog()"
  >
    Guardar
  </button>
</ng-template>

<ng-template
  #templateStepperButtons
  let-showBefore="showBefore"
  let-showNext="showNext"
  let-blockNext="blockNext"
>
  <span class="tw-space-x-3">
    <button
      *ngIf="showBefore"
      mat-raised-button
      class="app-btn-blue tw-mx-2"
      (click)="stepper.previous()"
    >
      Anterior
    </button>
    <button
      mat-raised-button
      class="app-btn-blue tw-mx-2"
      (click)="stepper.next()"
      *ngIf="showNext"
      [disabled]="blockNext"
    >
      Siguiente
    </button>
  </span>
</ng-template>
